module.exports = __webpack_public_path__ + "img/custom-quit.ec2b574a.svg";